import { Permission, PermissionType } from 'domain/_entities/permission.entity'
import { User } from 'domain/_entities/user.entity'
import { FeatureSwitch } from 'models/customer'

export type CustomerRoleType = 'ADMIN' | 'BU_ADMIN' | 'USER'

/**
 * Check if a User belongs to a Role type
 * @param user
 * @param roles
 * @category User
 */
export function isUserInRoles(
  user: User | undefined,
  roles: CustomerRoleType[]
): boolean {
  return (
    (user?.customer?.customer_roles ?? []).find(
      r => roles.includes(r.role as CustomerRoleType) && r.user_id === user?.id
    ) !== undefined
  )
}

/**
 * Check if a User has specific permissions
 * @remarks This function returns true if and only if the user has every and each of the permissions specified in the array.
 * @param userRolePermissions The permissions that the user have
 * @param permissions The permission or permissions to be checked
 * @category User
 */
export function hasUserPermissionsFn(
  userRolePermissions: Permission[],
  permissions: PermissionType | PermissionType[]
): boolean {
  const permissionsArray = Array.isArray(permissions)
    ? permissions
    : [permissions]
  return permissionsArray.every(permission =>
    userRolePermissions.some(uRPermission => uRPermission?.title === permission)
  )
}

/**
 * Check if a User has access to specific features
 * @param userFeatures
 * @param features
 */
export function hasUserEnabledFeaturesFn(
  userFeatures: FeatureSwitch[],
  features: FeatureSwitch[]
): boolean {
  if (features.length === 0) return false
  return features.every(feature => userFeatures.includes(feature))
}
